<div class='container-align-center margin-top'>
    <logo></logo>
</div>
<div class='container-align-center'>
    <mat-card *ngIf="!resetPassword.code">
      <mat-card-title>Reset password</mat-card-title>
      <mat-card-content *ngIf="!codeRequested">
        <p>Please enter e-mail address associated with your account to reset password</p>
        <form>
            <mat-form-field appearance="fill">
              <mat-label>Email</mat-label>
              <input type="email" matInput [formControl]="emailFormControl" placeholder="Ex. pat@example.com" [(ngModel)]="email" name="email">
              <mat-error *ngIf="emailFormControl.hasError('email')">Please enter a valid email address</mat-error>
              <mat-error *ngIf="emailFormControl.hasError('required')">Email is <strong>required</strong></mat-error>
            </mat-form-field>
        </form>
      </mat-card-content>
      <mat-card-actions *ngIf="!codeRequested">
        <button mat-stroked-button color="primary" [disabled]="emailFormControl.invalid" (click)="request()">Reset</button>
        <button mat-stroked-button (click)="cancel()">Cancel</button>
      </mat-card-actions>
      <mat-card-content *ngIf="codeRequested">
        <p>Reset password instructions were sent to your e-mail address</p>
        <a [routerLink]="['/login']">Return to login</a>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="resetPassword.code">
      <mat-card-title>Reset password</mat-card-title>
      <mat-card-content *ngIf="!passwordReset">
        <p>Please enter new password</p>
        <form>
          <mat-form-field appearance="fill">
            <mat-label>New password</mat-label>
            <input type="password" matInput [formControl]="passwordFormControl" placeholder="New password" [(ngModel)]="resetPassword.password" name="password">
            <mat-error *ngIf="passwordFormControl.hasError('required')">Password is <strong>required</strong></mat-error>
            <mat-error *ngIf="passwordFormControl.hasError('pattern')">Password is not enough <strong>strong</strong> (must be at least 8 characters length and contain one upper case letter, one lower case letter, one number and one special character)</mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Confirm password</mat-label>
            <input type="password" matInput [formControl]="confPasswordFormControl" placeholder="Confirm password" [(ngModel)]="confirmPassword" name="confirmPassword">
            <mat-error *ngIf="confPasswordFormControl.hasError('required')">Password is <strong>required</strong></mat-error>
            <mat-error *ngIf="confPasswordFormControl.hasError('notMatch')">Passwords must <strong>match</strong></mat-error>
          </mat-form-field>
        </form>
      </mat-card-content>
      <mat-card-actions *ngIf="!passwordReset">
        <button mat-stroked-button color="primary" [disabled]="!formValid()" (click)="save()">Save</button>
        <button mat-stroked-button (click)="cancel()">Cancel</button>
      </mat-card-actions>
      <mat-card-content *ngIf="passwordReset">
        <p>Reset password is complete successfully</p>
        <p>Please use the following link to <a [routerLink]="['/login']">login</a> with new credentials</p>
      </mat-card-content>
    </mat-card>
  </div>
